import DistributorLayout from '@/layouts/DistributorLayout.vue'
import PublicLayout from '@/layouts/PublicLayout.vue'

export default [
  {
    path: '/rental-files/create/:repairFileBoomerangId/products/:rentalProductId(\\d+)',
    name: 'rentalFileCreate',
    component: () => import('@/views/restricted/rental-files/create/RentalFileCreateView.vue'),
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      hideHeader: true,
      permissions: ['DISTRIBUTOR_RENTAL_CREATE'],
      menuSelected: 'repairFiles'
    }
  },
  {
    path: '/rental-files/:rentalFileBoomerangId',
    name: 'rentalFileDetail',
    component: () => import('@/views/restricted/rental-files/RentalFileDetailView.vue'),
    meta: {
      requiresAuth: true,
      layout: DistributorLayout,
      hideHeader: true,
      permissions: ['DISTRIBUTOR_RENTAL_READ'],
      menuSelected: 'repairFiles'
    }
  },
  {
    path: '/public/rental-files/add-product-picture',
    name: 'rentalFileAddPicture',
    component: () => import('@/views/public-access/rental-files/RentalFileAddPictureView.vue'),
    meta: {
      requiresAuth: false,
      publicCapability: true,
      layout: PublicLayout
    }
  },
  {
    path: '/public/rental-module/add-product-picture',
    redirect: (to) => ({ name: 'rentalFileAddPicture', query: to.query, hash: to.hash })
  }
]
